import { MainDashboard, CustomerList, PagesList, AddPage , OrderList , ServiceList , AddCustomer ,OrderDetails , Faqs , Profile , ContactSupport , OrderChatAdminView} from "../pages";
import VerificationRequestedList from "../pages/estimation/quotation/verificationrequestedlist";

const RouteArr = [

  {
    name: "MainDashboard",
    path: "/main-dashboard",
    key: "main-dashboard",
    route: "/main-dashboard",
    element: <MainDashboard />,
  },

  {
    name: "CustomerList",
    path: "customers/:customerType",
    key: "/customers/:customerType",
    route: "customers",
    element: <CustomerList />,
  },

  

   {
    name: "VerificationRequestedList",
    path: "customers/verification-requested",
    key: "/customers/verification-requested",
    route: "customers/verification-requested",
    element: <VerificationRequestedList />,
  },

  {
    name: "orderList",
    path: "orders",
    key: "/orders",
    route: "orders",
    element: <OrderList />,
  },

  {
    name: "Page",
    path: "pages",
    key: "/pages",
    route: "pages",
    element: <PagesList />,
  },

  {
    name: "PageEdit",
    path: "customer/edit/:id",
    key: "/customer/edit/:id",
    route: "customer/edit/:id",
    element: <AddCustomer />,
  },


  {
    name: "Profile",
    path: "profile",
    key: "/profile",
    route: "profile",
    element: <Profile />,
  },

  {
    name: "OrderDetails",
    path: "order/details/:id",
    key: "/order/details/:id",
    route: "order/details/:id",
    element: <OrderDetails />,
  },


  {
    name: "OrderDetails",
    path: "order/chat/:id",
    key: "/order/chat/:id",
    route: "order/chat/:id",
    element: <OrderChatAdminView />,
  },

  {
    name: "FaqEdit",
    path: "faqs",
    key: "/faqs",
    route: "faqs",
    element: <Faqs />,
  },


  {
    name: "PageEdit",
    path: "page/edit/:id",
    key: "/page/edit/:id",
    route: "page/edit/:id",
    element: <AddPage />,
  },

  {
    name: "ServiceList",
    path: "services",
    key: "/services",
    route: "services",
    element: <ServiceList />,
  },

  {
    name: "contact-support",
    path: "contact-support",
    key: "/contact-support",
    route: "contact-support",
    element: <ContactSupport />,
  },


];

export default RouteArr;



